export default __webpack_public_path__ + "static/media/left-img.96fcfdb5.svg";